import { Form, useSubmit } from "@remix-run/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ActionTypes } from "~/root";
import LoadingSpinner from "../LoadingSpinner";

export default function SubscribeEmailPopup({
  title,
  button,
}: {
  title: string;
  button: string;
}) {
  const { t } = useTranslation("blog");
  const [loading, setLoading] = useState(false);
  const submit = useSubmit();

  return (
    <div className="z-10 w-[90%] max-w-[550px] space-y-10 rounded-2xl bg-white px-8 py-11">
      <p className="text-lg font-semibold text-Secondary-Crayola-Space-Cs-700">
        {t(title + ".w1")}{" "}
        <span className="text-Semantic-Colors-S-info">{t(title + ".w2")}</span>
      </p>
      <Form
        action="/"
        method="post"
        className="flex flex-col items-stretch gap-[10px] text-sm"
        onSubmit={async (e) => {
          e.preventDefault();
          setLoading(true);
          submit(e.currentTarget);
        }}
      >
        <input
          type="hidden"
          name="_action"
          value={ActionTypes.EMAIL_SUBSCRIBE}
        />
        <input type="hidden" name="confirmEmail" id="confirmEmail" />
        <label htmlFor="email" className=" text-Secondary-Crayola-Space-Cs-700">
          {t("form.email")}
        </label>
        <input
          required
          type="email"
          name="email"
          id="email"
          placeholder="wearby@gmail.com"
          className="rounded-xl border border-Light-grey-Lg-100 p-[18px]"
          onChange={(e) => {
            (
              document.getElementById("confirmEmail") as HTMLInputElement
            ).value = e.target.value;
          }}
        />
        <button className="btn mt-8">
          {loading ? <LoadingSpinner /> : t(button)}
        </button>
      </Form>
    </div>
  );
}
